// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b03db677","455":"bfe87761","821":"92cac967"}[chunkId] + ".chunk.js";
};